<template>
  <div>
    <div
      v-if="showInput"
      :class="$style.inputValuePosition"
    >
      <InputValidator
        ref="inputValue"
        :class="$style.inputValidator"
        :config="{
          attribute: control.attribute,
          label: control.label,
          name: control.label,
        }"
        :tooltip="getTooltip()"
        @InputValidatorModel="(value) => handleChangeValue(value, $validator)"
      />
      <button
        :class="[$style.dropDownButton, { [$style.dropDownButtonWithLabel]: !!control.label }]"
        @click="showDropDownList"
      />
    </div>
    <DropDown
      v-if="!showInput"
      ref="dropdown"
      :label="control.label"
      :name="control.label"
      optionLabelKey="text"
      :options="attributeList"
      optionValueKey="value"
      :tooltip="getTooltip()"
      :value="handleDisplayValue(control)"
      @input="handleChangeValue"
    />
  </div>
</template>
<script>
import DropDown from 'client/components/FormValidation/DropDown.vue';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

export default {
  name: 'DynamicControlsCustomDropDown',
  components: {
    InputValidator,
    DropDown,
  },
  inject: ['$validator'],

  mixins: [
    DynamicControlsMixin,
  ],

  props: {
    value: {
      default: '',
      type: [String, Number],
    },
  },

  data: () => ({
    attributeList: [],
    showInput: false,
  }),

  computed: {
    customField() {
      return this.control.customField ? this.control.customField : {
        text: 'Custom Field',
        value: 'customField',
      };
    },
    validators() {
      // Validators for now are not required, it could be expanded in another feature.
      return this.control.validators;
    },
  },

  mounted() {
    const attributeList = this.getDisplayOptions(this.control);
    this.attributeList = attributeList;
    this.addCustomField();
    this.addSeparators();
  },

  methods: {
    addCustomField() {
      this.attributeList.push({
        text: this.customField.text,
        value: this.customField.value,
      });
    },
    addSeparators() {
      const separatorIndices = this.control.separatorIndices || [];
      separatorIndices.forEach((index) => {
        if (index > this.attributeList.length) return;
        this.attributeList.splice(index, 0, {
          text: '──────────',
          value: `separator-${index}`,
          disabled: true,
        });
      });
    },
    getDisplayOptions(control) {
      const { displayOptions, displayType } = control;
      const displayTypeCaps = displayType.toUpperCase();
      if (displayOptions && displayOptions[displayTypeCaps]) {
        return displayOptions[displayTypeCaps];
      }
      return displayOptions;
    },

    async handleChangeValue(value, $validator) {
      let handler;
      if (this.showInput) {
        handler = this.control.handleInputChange || this.handleChange;
        return handler(value, $validator);
      }
      handler = this.control.handleDropDownValueChange || this.handleChange;
      if (value === this.customField.value) {
        await this.handleInputTypeChange();
        return handler('', $validator);
      }
      return handler(value);
    },

    handleDisplayValue(control) {
      const handler = control.getDisplayValue || this.getDisplayValue;
      return handler(control);
    },

    async handleInputTypeChange() {
      this.showInput = true;
      await this.$nextTick();
      const inputValue = this.$refs.inputValue.getInputChild();
      inputValue.$refs.input.focus();
    },

    async showDropDownList() {
      this.showInput = false;
      await this.$nextTick();

      const bootstrapDropdown = this.$refs.dropdown.$children[1];
      bootstrapDropdown.visible = true;
    },
  },
};
</script>
<style module>
.dropDownButton {
  background: transparent;
  display: block;
  height: 33px;
  padding-right: 20px;
  position: absolute;
  right: 0;
  top: 0;
}

.dropDownButton::after {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #b3b2b1;
  content: '';
  height: 0;
  left: 17px;
  position: absolute;
  top: 15px;
  width: 0;
}

.dropDownButtonWithLabel {
  top: 22px;
}

.inputValidator label {
  font-size: 1rem !important;
  margin: 0 !important;
}

.inputValuePosition {
  position: relative;
}
</style>
